import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { setCurrency } from "@/lib/format";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = auth
  const [globalSettings, setGlobalSettings] = useState(null);

  const loadGlobal = async () => {
    try {
      const { data } = await api.get("/settings/global");
      setGlobalSettings(data);
      setCurrency(data);
    } catch (_) {}
  };

  const bootstrap = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadGlobal();
    } catch (_) {
      localStorage.removeItem("token");
      setUser(false);
    }
  };

  useEffect(() => {
    bootstrap();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.access_token);
    setUser(data.user);
    loadGlobal();
    return data.user;
  };

  const loginWithToken = async (token) => {
    localStorage.setItem("token", token);
    const { data } = await api.get("/auth/me");
    setUser(data);
    loadGlobal();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, loginWithToken, logout, globalSettings, refreshGlobal: loadGlobal }}>
      {children}
    </AuthContext.Provider>
  );
}

export { formatApiErrorDetail };
